import { useContext } from 'react'
import { Rxios } from 'rxios'
import { AxiosInstance } from 'axios'
import { AppStateContext } from './AppStateContext'

interface RestResult {
  rxios: Rxios
  rxiosAuth: Rxios
  rxiosAuth2FA: Rxios
  rest: AxiosInstance
}

export const useRest: () => RestResult = () => {
  const { rxiosClient, rxiosAuthorized, rxios2FA, axiosAuthorized } = useContext(AppStateContext)
  const rxios = rxiosClient
  const rxiosAuth = rxiosAuthorized
  const rxiosAuth2FA = rxios2FA
  const rest = axiosAuthorized
  return {
    rxios,
    rxiosAuth,
    rxiosAuth2FA,
    rest,
  }
}
